import React from 'react';
import ReactDOM from 'react-dom';
//import { Router, Route } from 'react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './css/index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

const Root = () => {
  return(
    <Router basename={'pt-timeline-dev'}>
      <Route path="/" component={App} />
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('App'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js